export default "/images/vendor/flag-icons/flags/1x1/ne.svg?66cb0cd9e54d34e883f1413fe7897c17";